import { openBlock as t, createElementBlock as a, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", { d: "M8 .25a.75.75 0 0 1 .75.75v2.19l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72V1A.75.75 0 0 1 8 .25Z" }, null, -1), n = /* @__PURE__ */ e("path", { d: "M12.599 14.25 9.488 9.584a1.417 1.417 0 0 1-.238-.786V6a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-.25v2.023l3.874 5.811A.75.75 0 0 1 14 15.75H2a.75.75 0 0 1-.624-1.166l1.994-2.99a.803.803 0 0 1 .012-.018L5.25 8.773V6.75H5a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75v2.798c0 .28-.083.553-.238.786l-1.11 1.666H8a.75.75 0 0 1 0 1.5H4.401l-1 1.5H12.6Z" }, null, -1), c = [
  o,
  n
];
function s(r, h) {
  return t(), a("svg", l, [...c]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
